export enum AIVersions {
  GPT_3_5_Turbo_1106_Standard = 'v1',
  GPT_3_5_Turbo_Standard = 'v2',
  GPT_3_5_Turbo_Extended_Tokens = 'v3',
  GPT_4o_Standard = 'v4',
  GPT_5_Mini = 'v5',
}

export enum AIFeature {
  Insights = 'insights',
  Questions = 'questions',
}

export const MAX_AI_QUESTIONS = 15;
export const MAX_USER_PROMPT_LENGTH = 3000;

/// Max file size for AI file upload in bytes
export const MAX_AI_FILE_SIZE = 20 * 1024 * 1024; // 20MB

/// Allowed file formats for AI file upload
export const ALLOWED_AI_FILE_FORMATS = [
  // PDFs (text-based and scanned/image)
  'application/pdf',
  // Images
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  // Office documents
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  // Other text formats
  'text/csv',
];
